exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-nok{color:#dee2e6;font-size:80px}.icon-ok{color:#28a745;font-size:75px}.welcome-text-disabled{color:#ced4da}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--1-2!./node_modules/sass-loader/dist/cjs.js??ref--1-3!./src/onboarding/welcome.scss
// module id = 3620
// module chunks = 0